import { render, staticRenderFns } from "./complainList.vue?vue&type=template&id=2be27a3c&scoped=true"
import script from "./complainList.vue?vue&type=script&lang=js"
export * from "./complainList.vue?vue&type=script&lang=js"
import style0 from "./complainList.vue?vue&type=style&index=0&id=2be27a3c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2be27a3c",
  null
  
)

export default component.exports